import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SG_TEMPLATES_STATISTICS } from 'constants/actions';

export default function Statistics() {
  const dispatch = useDispatch();
  const statistics = useSelector((s) => s.action_template?.statistics);

  useEffect(() => {
    dispatch({ type: SG_TEMPLATES_STATISTICS });
  }, [dispatch]);

  return (
    <div>
      <h2>Templates statistics</h2>
      <pre>{statistics ? JSON.stringify(statistics, null, 2) : 'Loading...'}</pre>
    </div>
  );
}
